import { frontendURL } from 'dashboard/helper/URLHelper';

const QuotesIndex = () => import('./pages/QuotesIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/quotes'),
      name: 'quotes_dashboard_index',
      component: QuotesIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
